export default {
  ROLES_MGMT_REQUEST: 'APP/ROLES_MGMT/ROLES_MGMT_REQUEST',
  ROLES_MGMT_SUCCESS: 'APP/ROLES_MGMT/ROLES_MGMT_SUCCESS',
  ROLES_MGMT_ERROR: 'APP/ROLES_MGMT/ROLES_MGMT_ERROR',
};
